import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'jhi-bary-collapse[label]',
  standalone: true,
  imports: [CommonModule, MDBBootstrapModulesPro],
  templateUrl: './bary-collapse.component.html',
  styleUrls: ['./bary-collapse.component.scss'],
})
export class BaryCollapseComponent {
  @Input() label = 'SET_LABEL';
  @Input() icon?: string;
  @Input() withArrow = true;
  @Input() subCollapse = false;
  @Input() isCollapsed = true;

  @Output() collapseEvent = new EventEmitter<any>();
}
